export interface NavItem {
  displayName: string;
  iconName: string;
  route?: string;
  children?: NavItem[];
  style?: any;
}

export const MenuRouteID = {
  'HOME': 1,
  'ANALYTICS': 2,
  'REVENUE': 3,
  'FOOTFALL': 4,
  'CHARGEBOX': 5,
  "DEEPDIVE": 6,
  'OPERATORS': 7,
  'CHARGING_STATIONS': 8,
  'STATIONS': 9,
  'ADD_STATION': 10,
  'CHARGING_PROFILE': 11,
  'CHARGING_TRANSACTION': 12,
  'TARIFF': 13,
  'EVUSERS': 14,
  'MOBILE_USERS': 15,
  'WALLETS': 16,
  'TRANSACTIONS': 17,
  'RFID': 18,
  'REFER_FRIEND': 19,
  'BILLING': 20,
  'RECONSILLATION': 21,
  'SETTLEMENT': 22,
  'CHARGER': 23,
  'SCHEDULE': 24,
  'USER_MGMT': 25,
  'TENANTS': 26,
  'ROLES': 27,
  'GROUPS': 28,
  'SERVICE_REQUEST': 29,
  'COMMUNICATIONS': 30,
  'INFO_UPDATES': 31,
  'ALERTS': 32,
  'CMS_USERS': 33,
  'TARIFF_MANAGEMENT': 62,
  'ROAMING_ANALYTICS' : 68,
  "TABS": {
    "DEVICE_SPEC": 34,
    "DEVICE_CONFIG": 35,
    "DEVICE_MGMT": 36,
    "DEVICE_TRANS": 37,
    "DEVICE_LOGS": 38,
    "GENERAL_DETAILS": 59,
    "AMENITIES": 39,
    "STATION_IMAGES": 40,
    "OPERATOR_DETAILS": 41,
    "MAPPING": 42,
    "STATION_DETAILS": 43,
    "CONSOLIDATED_RFID": 44,
    "ASSIGNED_RFID": 57,
    "PENDING_TRANS": 45,
    "FAILED_TRANS": 46,
    "COMPLETED_TRANS": 58,
    "ACCOUNT_DETAILS": 47,
    "ROLE_MAPPING": 48,
    "ROLE_USER_MAPPING": 49,
    "ROLE_DETAILS": 50,
    "GROUP_DETAILS": 51,
    "GROUPS_USER_MAPPING": 52,
    "GALLERY":60,
    "GROUP_MAPPING":61
  },
  "PROFILES": {
    'FAQ': 53,
    'CHOOSE_PREFERENCES': 54,
    'UPDATE_COUNTRY': 55,
    'UPDATE_LANGUAGE': 56,
  }
}
